module.exports = __webpack_public_path__ + "img/python-dark.39b2bdb3.svg";